import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { ReportsTable } from "./ReportTable/ReportTable";

const OtherReports = () => {
  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.OtherReportingPageViewed,
    });
  };

  return (
    <DPRestrictedPage
      title={"Other Reports"}
      onPageLoad={onPageLoad}
      permissionKey="canViewReports"
    >
      <ReportsTable />
    </DPRestrictedPage>
  );
};

export default OtherReports;
